module.exports = {
  back: 'Geri',
};
